import React, { useState } from "react";
import { auth } from "./firebase"; // Firebase-Initialisierung importieren

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      await auth.sendPasswordResetEmail(email);
      setMessage("Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.");
    } catch (error) {
      setError(
        "Fehler beim Senden der E-Mail. Bitte überprüfe die E-Mail-Adresse."
      );
    }
  };

  return (
    <div className="container">
      <div className="container py-5">
        <div className="container mt-5">
          <p className="pt-3 col-lg-9 mx-auto"></p>
          <h2>Passwort vergessen</h2>
          <p>
            Gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen deines
            Passworts zu erhalten.
          </p>
          <form onSubmit={handlePasswordReset}>
            <div className="form-group">
              <label>E-Mail-Adresse:</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Passwort zurücksetzen
            </button>
          </form>
          {message && <p className="text-success mt-3">{message}</p>}
          {error && <p className="text-danger mt-3">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
